import Vue from 'vue'
import Router from 'vue-router'
import Static from '@/components/Static'
import News from '@/components/News'
import Projects from '@/components/Projects'
import Project from '@/components/Project'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:route(projekte)/:filter?',
      name: 'projekte',
      components: {
        'overlay': Projects
      },
      children: [
        {
          path: '/:route(projekte)/:id/:stub',
          name: 'projekt',
          component: Project
        }
      ]
    },
    {
      path: '/:route(news)/:id?/:stub?',
      name: 'news',
      components: {
        'overlay': News
      }
    },
    /* {
      path: '/:id/:stub',
      name: 'new',
      components: {
        'overlay': News
      }
    }, */
    {
      path: '/:route/:id?/:stub?',
      name: 'overlay',
      components: {
        'overlay': Static
      }
    },
    {
      path: '/',
      name: 'home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js